import { HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  AjaxData,
  AjaxService,
  blankHttpParamsWithCustomEncoder,
  formUrlEncodedHttpOptions,
} from '../core/ajax.service';
import { AppConfigService } from '../core/app-config.service';
import { Customer } from '../customers/customer-common';
import { CustomerVoiceRouterService } from '../core/cv-router.service';
import { ApiRoutesV1 } from '../common/routes';
import { NoPreferredSitesDialogComponent } from '../settings/preferred-sites/no-preferred-sites-dialog.component';
import { NoListingBuilderDialogComponent } from '../preview-send-email/no-listing-builder-dialog.component';

@Injectable()
export class SendSmsService {
  partnerId: string;
  accountGroupId: string;
  isPaidAccount: boolean;

  constructor(
    private readonly ajaxService: AjaxService,
    private appConfigService: AppConfigService,
    private customerVoiceRouter: CustomerVoiceRouterService,
    public dialog: MatDialog,
  ) {
    this.appConfigService.appConfig.subscribe((config) => {
      this.partnerId = config.partnerId;
      this.isPaidAccount = config.isPaidVersion;
    });
    this.customerVoiceRouter.accountGroupId.subscribe((accountGroupId) => {
      this.accountGroupId = accountGroupId;
    });
  }

  public sendReviewRequestSms(recipients: Customer[], templateId?: string): Observable<HttpResponse<AjaxData>> {
    const params: any = {};
    if (templateId) {
      params['templateId'] = templateId;
    }

    const bulkRecipientsPayload: HttpParams = blankHttpParamsWithCustomEncoder.set(
      'contactsJson',
      JSON.stringify(recipients),
    );

    return this.ajaxService.post(ApiRoutesV1.sendSmsRequestsBulk, bulkRecipientsPayload, {
      ...formUrlEncodedHttpOptions,
      params: params,
    });
  }

  public openNoPreferredSitesDialog(): void {
    this.dialog.open(NoPreferredSitesDialogComponent, {
      data: {
        messageType: 'SMS',
      },
    });
  }

  public openNoListingBuilderDialog(): void {
    this.dialog.open(NoListingBuilderDialogComponent);
  }
}
